// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".debug-card {\n  position: fixed !important;\n  width: 300px;\n  height: 800px;\n  overflow: scroll;\n}\nth {\n  text-align: right;\n}\n.debug-najomca {\n  right: 0;\n}", ""]);
// Exports
module.exports = exports;
